/**
 * Admin Center Client Mod 定义
 *
 * admin-client-mod 的运行时定义，提供：
 * - IAdminSlotsService: 管理员中心 slot 注册服务
 * - 管理员中心页面路由注册
 *
 * 第三方业务 Mod 通过 ADMIN_SLOTS_INTERFACE_TAG
 * 从 DI 容器获取 IAdminSlotsService 实例，注册自己的 slot。
 */
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { ADMIN_SLOTS_INTERFACE_TAG, } from '@hvsin/admin-contracts';
import { AdminSlotsService } from './admin-slots-service.js';
import { AdminRegistrar } from './admin-registrar.js';
/**
 * admin-client-mod
 *
 * 管理员中心页面，支持第三方通过 slot 机制扩展管理界面。
 *
 * 使用方式：
 * ```typescript
 * import { adminClientMod } from '@hvsin/mod-admin-client'
 *
 * await container.loadMods([adminClientMod, ...businessMods])
 * ```
 *
 * 第三方 Mod 注册 slot：
 * ```typescript
 * import { ADMIN_SLOTS_INTERFACE_TAG } from '@hvsin/admin-contracts'
 *
 * const myMod: IMod = {
 *   name: 'my-admin',
 *   serviceDefs: [{
 *     serviceTag: 'myRegistrar',
 *     serviceImpl: class {
 *       constructor({ adminSlots }: any) {
 *         adminSlots.registerSlot({
 *           id: 'my-section',
 *           label: '我的管理',
 *           component: MyPanel,
 *         })
 *       }
 *     },
 *     dependencies: [ADMIN_SLOTS_INTERFACE_TAG],
 *   }],
 * }
 * ```
 */
export const adminClientMod = {
    name: 'admin-center-client',
    modDependencies: ['ui-registry'],
    serviceDefs: [
        {
            serviceTag: 'adminSlots',
            serviceImpl: AdminSlotsService,
            serviceInterfaceTag: ADMIN_SLOTS_INTERFACE_TAG,
        },
        {
            serviceTag: 'adminRegistrar',
            serviceImpl: AdminRegistrar,
            dependencies: [
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                ADMIN_SLOTS_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map